import { defineStore } from 'pinia';
import { httpAPI } from '@/services/ajax';
import { useAlertStore } from './alert';
import { shouldShowError } from '@/utils/errorHelper';
import app from '@/main.js';

export const useRoleStore = defineStore('role', {
    state: () => ({
        roles: [],
        fetching: false,
        fetchPromise: null,
    }),
    actions: {
        fetchRoles() {
            // If we're already fetching, return the actual fetching promise
            if (this.fetching && this.fetchPromise) {
                return this.fetchPromise;
            }

            this.fetching = true;
            const url = app.config.globalProperties.$env.apiRoot + 'role/read';
            const vm = this;

            this.fetchPromise = httpAPI(
                url,
                null,
                'GET',
                app.config.globalProperties.$router
            )
                .then((response) => {
                    if (response.success) {
                        vm.roles = response.data || [];
                    } else if (shouldShowError(response)) {
                        const alertStore = useAlertStore();
                        alertStore.pushError(
                            'Failed to fetch roles: ' +
                                (response?.message || 'Unknown error')
                        );
                    }
                    return vm.roles;
                })
                .catch((error) => {
                    const alertStore = useAlertStore();
                    alertStore.pushError(
                        'Unable to load roles. Please refresh the page.' +
                            (error?.message ? ': ' + error.message : '')
                    );
                    vm.roles = [];
                    return vm.roles;
                })
                .finally(() => {
                    vm.fetching = false;
                    vm.fetchPromise = null;
                });

            return this.fetchPromise;
        },
        syncRoles() {
            if (this.roles && this.roles.length > 0) {
                return Promise.resolve(this.roles);
            }
            return this.fetchRoles();
        },
        clear() {
            this.roles = [];
            this.fetching = false;
            this.fetchPromise = null;
        },
    },
    getters: {
        getRoleOptions(state) {
            return state.roles.map((role) => ({
                text: role.name,
                value: String(role.id),
            }));
        },

        // Find role by ID
        getRoleById: (state) => (id) => {
            return state.roles.find((role) => role.id === parseInt(id));
        },
    },
});
